import { replaceQuotesMain } from './replace.quotes.module.js';
export { applyTypograph };

// https://wiki.oooinex.ru/pages/viewpage.action?pageId=99849064

// проверка в консоли: applyTypograph(applyTypograph(`ТУТ_ИНПУТ`));
function applyTypograph(strParam, isEngSite) {
	let str = strParam;
	str = replaceQuotesMain(str, isEngSite);
	str = replaceEnglishApostrophe(str);
	str = replaceHyphenDash(str);
	str = removeAbbrDots(str);
	str = removeSpaces(str);
	str = fixThousand(str);
	str = removeYo(str);
	str = fixTime(str);
	str = fixDoubleNormalizedTime(str);
	str = fixSentenceDot(str);
	str = fixConjunctionComma(str);
	str = addSpaceAfterPunctuation(str);
	str = fixFullName(str);
	str = addNbsp(str);
	str = fixPhones(str);

	return str;
}

// апостроф в англ текстах
// replaceEnglishApostrophe(`O'hara 'jus kiddin'`)
function replaceEnglishApostrophe(str) {
	return str.replaceAll(/([a-zA-Z]+)[′'ˈꞌ]([a-zA-Z]*)/gm, '$1’$2');
}

// тире и дефис
// replaceHyphenDash(`бледно一розовый, миру - мир`)
function replaceHyphenDash(str) {
	return str
		.replaceAll(/([a-zA-Zа-яА-ЯёЁ]+)[−‐‑ー一—]([a-zA-Zа-яА-ЯёЁ]+)/gm, '$1-$2')
		.replaceAll(/([a-zA-Zа-яА-ЯёЁ]+) - ([a-zA-Zа-яА-ЯёЁ]+)/gm, '$1 — $2');
}

// удаление точек в млн, млрд, м, км, га
// removeAbbrDots(`<p>3000 км длина, ширина - 5 млн.м, площадь - 12 га.</p> поезд. `) // поезд с точкой и пробелом - тоже нужен, была бага с удалением
function removeAbbrDots(str) {
	return str
		.replaceAll(/(млн|млрд|м|км|га)\.([a-zA-Zа-яА-ЯёЁ])/gm, '$1 $2')
		.replaceAll(/(млн|млрд|м|км|га)\.(?!<\/\p>)/gm, '$1');
}

// удаление пробелов
// removeSpaces(`7 % | 100 % | после этого идет запятая , | ( текст )`)
function removeSpaces(str) {
	return str
		.replaceAll(/([0-9]+) %/gm, '$1%')
		.replaceAll(/\s+,/gm, ',')
		.replaceAll(/\( +(.+) +\)/gm, '($1)');
}

// добавление неразрывных пробелов
// addNbsp(`№ 15 | г. Москва | ул. Раменки | д. Чкалово | стр. 7 | рис. 8 | к. 17 | кв. 18 | ООО ИнЭкс | ПАО "Промсвязьбанк" | два слова`)
function addNbsp(str) {
	return str
		.replaceAll(/(№| стр.| рис.| к.| кв.) ([0-9]+)/gm, '$1&nbsp;$2')
		.replaceAll(/( г.| ул.| д.) ([а-яА-ЯёЁ]+)/gm, '$1&nbsp;$2')
		.replaceAll(/( ООО| АО| ПАО| ОАО) ([а-яА-ЯёЁ"«&]+)/gm, '$1&nbsp;$2');
}

// добавляем точку в сокращение тыс
// fixThousand(`<p>адекватыс, 15 тыс и 20 тыс, и 5 тыс. (здесь точка не должна добавиться)</p>`)
function fixThousand(str) {
	// здесь должна была быть простая регулярка /\bтыс\b/ - но она не работает с кириллицей
	// поэтому то же самое, но страшно выглядящее, взято отсюда https://ru.stackoverflow.com/a/1514436
	const slovo = 'тыс';
	const regex = new RegExp(String.raw`(?<!\p{L}\p{M}*|[\p{N}_])${slovo}(?!\.)(?![\p{L}\p{N}_])`, 'gmu');

	return str.replaceAll(regex, `${slovo}.`);
}

// удаление ё отовсюду кроме фамилии Белозёров
// да, ё останется в слове Белозё или ёров, но вероятность такого пренебрежимо мала
// removeYo(`ёкарный бабай Белозёров ёу Ё`)
function removeYo(str) {
	return str.replaceAll(/(?!Белоз)ё(?!ров)/gm, 'е').replaceAll(/(?!Белоз)Ё(?!ров)/gm, 'Е');
}

// приведение времени из разных форматов к формату 18:45
// fixTime(` 08 : 13 | 08 : 14.  | 08 :15. | 08-16. | 108 : 123 (не должно) | 35:75 (не должно)`)
function fixTime(str) {
	return str.replaceAll(/([ >])(0[0-9]|1[0-9]|2[0-3])[ ]?[-:−‐‑ー一—][ ]?([0-5][0-9])([ <.])/gm, '$1$2:$3$4');
}

// приведение времени из формата 18:45 - 19:45 в формат 18:45-19:45 (после fixTime!)
// fixDoubleNormalizedTime(` 08:13 | 08:14. | 18:45 - 19:45 | 18:45 - 19:456 (не должно)`);
function fixDoubleNormalizedTime(str) {
	return str.replaceAll(
		/\b(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])[ ]?[-:−‐‑ー一—][ ]?(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])\b/gm,
		'$1:$2-$3:$4',
	);
}

// точка в конце параграфа, если нет точки/вскл/вопроса/многоточия (& потому что хтмл-сущности типа &hellip;)
// fixSentenceDot(`<p>Предложение</p> | <p>Предложение.</p> (не должно) | <p>Предложение!</p> (не должно) | <p>Предложение?</p> (не должно) | <p>Предложение…</p> (не должно)`);
function fixSentenceDot(str) {
	return str.replaceAll(/<p>([^.!?…]+?)(?!\.)(?!…)(?!!)(?!&)(?!\?)<\/p>/gm, '<p>$1.</p>');
}

// запятая перед союзами «а», «но», «зато»
// fixConjunctionComma(`мал золотник а дорог | мал золотник но дорог | мал золотник зато дорог | тест нос (не должно)`);
function fixConjunctionComma(strArg) {
	let str = strArg;
	['а', 'но', 'зато'].forEach((slovo) => {
		str = fixConjunctionCommaInternal(str, slovo);
	});

	return str;

	function fixConjunctionCommaInternal(str, slovo) {
		// здесь должна была быть простая регулярка /\bтыс\b/ - но она не работает с кириллицей
		// поэтому то же самое, но страшно выглядящее, взято отсюда https://ru.stackoverflow.com/a/1514436
		const regex = new RegExp(String.raw`([а-яА-ЯёЁ]) ${slovo} ([а-яА-ЯёЁ])`, 'gmu');

		return str.replaceAll(regex, `$1, ${slovo} $2`);
	}
}
// инициалы не разделяются пробелом, отделены от фамилии неразрывным пробелом, все отображается на одной строке
// fixFullName(`А. Б. Пугачева | И О Я (не должно) | и о яяяяя (не должно)`);
// амперсанд & - потому что инициалы
function fixFullName(str) {
	return str.replaceAll(/([А-ЯЁ])\.[ ]?([А-ЯЁ])\. ([А-ЯЁ])/gm, '$1.$2.&nbsp;$3');
}

// после любого знака препинания должен быть 1 пробел или параграф: проверяем, если нет - ставим;
// группа (?![А-Я]\.) - для обхода бага при повторном проходе по строкам вида А.Б. Пугачева.
// addSpaceAfterPunctuation(addSpaceAfterPunctuation('один,два, три, А.Б. Пугачева, стр.&nbsp;, четыре, тест.И грянул гром.</p>'))
function addSpaceAfterPunctuation(str) {
	return str.replaceAll(/([.,!?…])(?! )(?![А-Я]\.)(?!&)(?!<\/)/gm, '$1 ');
}

// Считаем телефоном группу от 3 до 11 цифр, между которыми в обязательном порядке есть минимум 1 тире или дефис, при этом перед первой цифрой стоит либо +, либо скобка, либо пробел/перенос строки. Если мы находим такую конструкцию, то мы не должны позволять разбивать ее на разные строки, а превращать в неразрывную конструкцию
// fixPhones('+7 (888) 555-66-77 | 495 123-45-67 | (12345) 3-12-34 | 495 3-12 | 1300 00 (не должно) | 1300 000 000 (не должно) | (1300-555) (не должно) | 07:00 29 февраля (не должно)')
function fixPhones(strArg) {
	let str = strArg;
	const matches = str.match(/((\+\d{1,5}\s)?\(?\d{1,5}\)?[\s-]\d{0,3}[\s-]\d{0,3}[\s-]?\d{1,3})/gm);
	if (matches) {
		matches
			.filter((item) => {
				const digitsMatch = item.match(/\d/g);

				return digitsMatch.length >= 3 && digitsMatch.length <= 11 && item.includes('-');
			})
			.forEach((item) => {
				str = str.replace(item, item.replaceAll(' ', '&nbsp;'));
			});
	}

	return str;
}
